import { useInfiniteQuery } from '@tanstack/react-query';
import { likedFolderService } from 'shared/src/api';
import { queryKey } from 'shared/src/constant';

export const useLikedFolders = () => {
  return useInfiniteQuery({
    queryKey: queryKey.getInfiniteLikeFolders,
    queryFn: ({ pageParam }) => likedFolderService.get({ last_sno: pageParam }),
    initialPageParam: undefined as number | undefined,
    getNextPageParam: ({ folders }) => {
      if (folders.length === 0) return undefined;
      const lastSno = folders[folders.length - 1].sno;
      if (lastSno === 0) return undefined;
      return lastSno;
    },
    select: data => data.pages.flatMap(page => page.folders),
  });
};
